<template>
  <b-container>
    <b-modal v-model="richtextEditVisible" title="edit rich text content" @ok="onModalOk" :ok-disabled="aiSubmitting" :ok-title="activeTab === 2 ? (aiSubmitting ? 'updating...' : 'update with AI') : 'OK'" size="xl" modal-class="view-editor-modal">
      <template #title>
        edit rich text content
        <modal-help topic="edit-richtext" />
      </template>
      <div class="edit-modal-content">
        <b-tabs v-model="activeTab" content-class="tab-body" nav-class="view-editor-tabs" pills>

          <b-tab title="General" active>
            <div class="tab-section">
              <div class="section-heading">Naming</div>
              <div class="field-row">
                <label class="field-label">
                  unique title
                  <b-form-input v-model="uniqueTitle" placeholder="richtext unique title" required />
                </label>
              </div>
              <div class="field-row">
                <label class="field-label">
                  title
                  <b-form-input v-model="title" placeholder="richtext title" required />
                </label>
              </div>
            </div>
          </b-tab>

          <b-tab title="Content">
            <div class="tab-section">
              <div class="section-heading">Rich Text Content</div>
              <p class="section-desc">edit the static content that will be displayed on this view</p>
              <RichTextEditor v-model="richTextContent" :editable="true" />
            </div>
          </b-tab>

          <b-tab title="AI">
            <ViewAiPanel v-model="aiPrompt" :error="aiError || ''" :submitting="aiSubmitting" />
          </b-tab>

        </b-tabs>
      </div>
    </b-modal>
  </b-container>
</template>

<script>

  import RichTextEditor from './RichTextEditor.vue'
  import { submitViewAi } from '../lib/view-ai.js'
  import ViewAiPanel from './ViewAiPanel.vue'

  export default {
    name: `richtextEdit`,
    data () {

      return {
        richtextEditVisible: false,
        activeTab: 0,
        aiPrompt: ``,
        aiError: ``,
        aiSubmitting: false,
        aiSavedUniqueTitle: ``,
        uniqueTitle: ``,
        title: ``,
        richTextContent: ``,
        parentDesigner: null
      }
    },
    components: {
      RichTextEditor,
      ViewAiPanel
    },
    methods: {
      showEditRichtextComponent () {

        this.activeTab = 0
        this.aiPrompt = ''
        this.aiError = ''
        this.aiSubmitting = false
        this.aiSavedUniqueTitle = this.uniqueTitle
        this.richtextEditVisible = true
      },
      async onModalOk (event) {

        const handled = await submitViewAi(this, event, { visibleKey: 'richtextEditVisible', tabIndex: 2 })

        if (!handled) return this.save()
      },
      save () {

        this.parentDesigner.saveActiveComponent({
          uniqueTitle: this.uniqueTitle,
          title: this.title,
          richTextContent: this.richTextContent
        })
      }
    }
  }
</script>
